module.exports = __webpack_public_path__ + "img/icon_sm_kcdbsq.88b76dc4.png";